import { createFileRoute } from '@tanstack/react-router'
import ManageCompanies from '../../../../containers/ManageUsers/components/ManageCompanies'

export const Route = createFileRoute(
  '/_authenticated/userManagement/companies/'
)({
  component: ManageCompanies
})
